import { apiV1 } from '~/services/api';

function generateToken(isTest: boolean | string) {
  return apiV1.request({
    url: '/authentication_tokens',
    method: 'POST',
    data: {
      created: null,
      test: isTest,
      token: null,
    },
  });
}

function getToken() {
  return apiV1.request({
    url: '/authentication_tokens',
  });
}

function deleteToken(token: string) {
  return apiV1.request({
    method: 'DELETE',
    url: `/authentication_tokens/${token}`,
  });
}

export { generateToken, getToken, deleteToken };
